import { createStore } from "vuex";

export default createStore({
  state: {
    isAuthenticated: false,
    userId: "",
    userName: "",
    Pmcc: "",
    backdtyn: localStorage.getItem("backdtyn"),
    compid: localStorage.getItem("compid"),
    compid1: localStorage.getItem("compid1"),
    mcdes: localStorage.getItem("mcdes"),
    cname: localStorage.getItem("cname"),
    cadd1: localStorage.getItem("cadd1"),
    cadd2: localStorage.getItem("cadd2"),
    cadd3: localStorage.getItem("cadd3"),
    datef: localStorage.getItem("datef"),
    datet: localStorage.getItem("datet"),
    ImagePath: "/menuimg",
    IsAdmin: localStorage.getItem("IsAdmin"),
    version: "2.56.0",
    logoPathVue: new URL("@/assets/kvr.jpg", import.meta.url).href,
    logoPath: new URL("@/assets/kvr.jpg", import.meta.url).href,
  },
  mutations: {},
  actions: {},
  modules: {},
});
